import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "config-client-container bsp-page" }
const _hoisted_2 = { class: "main-content bsp-page__content" }
const _hoisted_3 = {
  class: "bsp-section access-token-section",
  "aria-labelledby": "access-token-title"
}
const _hoisted_4 = { class: "bsp-advanced-section credentials-section" }
const _hoisted_5 = { class: "bsp-advanced-section__content" }

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { onMounted, ref } from 'vue'
import { User } from '../services/AuthService/types'
import { Establishment, WhatsappCredentials } from '../services/EstablishmentService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import { AButton, AIcon, AInput, ATag } from '@adereso-ai/vue-components'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigClientView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')

const DownloadmediaUrlResponse = ref('')
const mediaID = ref('')
const mediaUrl = ref('')

const defaultCredentials = {
  access_token: '',
  expires_in: '',
  token_type: '',
  scope: '',
  type: '',
  status: '',
  refresh_token: ''
}

const credentials = ref<WhatsappCredentials>(defaultCredentials)

const configBreadcrumbs = [
  { title: 'WhatsApp Accounts', icon: 'tabler:brand-whatsapp', to: { name: 'whatsapp-business-accounts' } },
  { title: 'Client settings', disabled: true }
]

async function downloadMedia () {
  if (mediaUrl.value === '') {
    toastError('Media URL is required')
    return
  }

  const metaService = await MetaService.getInstance()
  try {
    const mediaUrlResp = await metaService.downloadMediaUrl(mediaID.value, mediaUrl.value)
    DownloadmediaUrlResponse.value = mediaUrlResp
  } catch (error) {
    toastError(error as string)
  }
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    toastError(error as string)
  }
}

async function getAccessToken () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const response = await establishmentService.getEstablishmentAccessToken()
    credentials.value = response
  } catch (error) {
    toastError(error as string)
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  await getAccessToken()

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BspPageHeader, {
        breadcrumbs: configBreadcrumbs,
        title: "Client settings",
        description: `Technical credentials for ${currentEstablishment.value?.name || 'the organization'}.`,
        eyebrow: "BSP integration",
        icon: "tabler:settings"
      }, {
        meta: _withCtx(() => [
          (currentEstablishment.value)
            ? (_openBlock(), _createBlock(_unref(ATag), {
                key: 0,
                text: currentEstablishment.value.name,
                color: "brand",
                type: "secondary"
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["description"]),
      _createElementVNode("section", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bsp-section-heading" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", { class: "bsp-section-heading__eyebrow" }, "Private credential"),
            _createElementVNode("h2", { id: "access-token-title" }, "Access token"),
            _createElementVNode("p", null, "Use this token only in authorized integrations. Do not share it in public channels.")
          ])
        ], -1)),
        _createVNode(_unref(AInput), {
          modelValue: credentials.value.access_token,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((credentials.value.access_token) = $event)),
          type: "password",
          label: "Access token",
          placeholder: "No token configured",
          "show-visibility-toggle": "",
          autocomplete: "off"
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(AButton), {
          color: "blue",
          "prepend-icon": "tabler:device-floppy",
          onClick: downloadMedia
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode(" Save settings ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("details", _hoisted_4, [
        _createElementVNode("summary", null, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, [
            _createElementVNode("strong", null, "Full response"),
            _createElementVNode("small", null, "Technical information returned by the backend.")
          ], -1)),
          _createVNode(_unref(AIcon), {
            icon: "tabler:chevron-down",
            size: "18"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("pre", null, _toDisplayString(credentials.value), 1)
        ])
      ])
    ])
  ]))
}
}

})